







































































































import {
  computed,
  defineComponent,
  PropType,
  getCurrentInstance
} from "@vue/composition-api";
import OccModal from "@/components/Atoms/OccModal/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccIcon from "@/components/Atoms/OccIcon/index.vue";
import Draggable from "vuedraggable";
import styleVars from "@/assets/styles/vars-for-script.scss";
import { CsvColumns } from "./types";
import { sendGaEvent } from "@/helpers/ga-helper";

export default defineComponent({
  name: "CsvCustomizeModal",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    includedColumns: {
      type: Array as PropType<CsvColumns[]>,
      default: () => []
    },
    excludedColumns: {
      type: Array as PropType<CsvColumns[]>,
      default: () => []
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  components: {
    OccModal,
    OccButton,
    OccHeading,
    OccIcon,
    Draggable
  },
  setup(props, { emit }) {
    const privateIncludedColumns = computed({
      get() {
        return props.includedColumns;
      },
      set(newValue) {
        emit("updateIncludedColumns", newValue);
      }
    });
    const privateExcludedColumns = computed({
      get() {
        return props.excludedColumns;
      },
      set(newValue) {
        emit("updateExcludedColumns", newValue);
      }
    });

    const addItem = (item1Index: number) => {
      const tempIncluded = [...props.includedColumns];
      const tempExcluded = [...props.excludedColumns];
      const selectedItem = tempExcluded.splice(item1Index, 1)[0];
      tempIncluded.push(selectedItem);

      privateExcludedColumns.value = tempExcluded;
      privateIncludedColumns.value = tempIncluded;
    };

    const deleteItem = (item1Index: number) => {
      const tempIncluded = [...props.includedColumns];
      const tempExcluded = [...props.excludedColumns];
      const selectedItem = tempIncluded.splice(item1Index, 1)[0];
      tempExcluded.push(selectedItem);

      privateExcludedColumns.value = tempExcluded;
      privateIncludedColumns.value = tempIncluded;
    };
    const apply = () => {
      const applyItemList = props.includedColumns.map(v => v.name);
      emit("apply", applyItemList);
      closeModal();
    };

    const instance = getCurrentInstance();
    const closeModal = () => {
      if (instance) {
        sendGaEvent(instance.proxy, {
          gaEventCategory: "モーダル_CSVダウンロード_閉じる"
        });
      }
      emit("close");
    };

    return {
      addItem,
      deleteItem,
      styleVars,
      apply,
      closeModal,

      privateIncludedColumns,
      privateExcludedColumns
    };
  }
});
